export default "__VITE_ASSET__ed07c487__"